import React from 'react';

import type { CompanyListDetails } from '../../../../utils/companyListFilters';
import { getActivityLabels } from '../../../../utils/companyListFilters';

interface ActivityBadgesProps {
  details: CompanyListDetails;
  loading?: boolean;
}

/** Activity cell of the company lists: DJ activities, then the CCI mentions DJ does not state. */
export default function ActivityBadges({ details, loading = false }: ActivityBadgesProps) {
  return (
    <div className="flex flex-wrap gap-1">
      {loading ? (
        <div className="animate-pulse space-y-1">
          <div className="h-6 w-24 rounded bg-gray-200" />
          <div className="h-6 w-32 rounded bg-gray-200" />
        </div>
      ) : (
        getActivityLabels(details).map((activity) => (
          <span key={activity} className="rounded bg-rgpd-blue-dark px-2 py-1 text-xs text-white">
            {activity}
          </span>
        ))
      )}
    </div>
  );
}
